const directory = [
  {
    directory_path: 'access-logs',
    directory_users: ['user1', 'user2', 'user3'],
  },
  {
    directory_path: 'logs',
    directory_users: ['user_01', 'user_02'],
  },
  {
    directory_path: 'public_ftp',
    directory_users: ['user-01', 'user-02', 'user.01'],
  },
];

export default directory;
